export const PAGE_TITLES = {
	'/': 'Dashboard',
	'/orders': 'Orders',
	'/orders/:orderId/:source': 'Order Details',
	'/products': 'Products',
	'/products/:productId': 'Product Details',
	'/account/me': 'My Account',
	'/access-required': 'Access Required',
	'/maintenance': 'Maintenance',
	'/404': '404',
	'/contact/us': 'Contact Us',
	'/account/impersonate': 'Impersonate',
	'/search/:searchKey/*': 'Search Results',
};

export const MAIN_NAVLINKS = [
	{ label: 'dashboard', href: '/' },
	{ label: 'orders', href: '/orders' },
	{ label: 'products', href: '/products' },
];
